export enum ApiErrorCode {
  OptimisticConcurrency = 'OptimisticConcurrencyException',
}
